import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 82-refresh
 * @see {GlyphIcon}
 */
const RefreshIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M27.99908,15.83618A12.00008,12.00008,0,0,1,16.71484,27.97852c-.24414.01464-.48828.022-.73046.022a11.89341,11.89341,0,0,1-7.17121-2.39478L7.42542,27.16956a.5.5,0,0,1-.85975-.21326L5.08826,20.90479a.5.5,0,0,1,.54571-.615l6.18421.74732a.5.5,0,0,1,.314.82825L10.81372,23.3512A8.998,8.998,0,0,0,24.99817,15.798a1.07162,1.07162,0,0,1,.31824-.8341,1.03419,1.03419,0,0,1,.80731-.26123l1.00909.12207a1.08451,1.08451,0,0,1,.61676.3247A.93076.93076,0,0,1,27.99908,15.83618ZM6.68359,17.03613a1.07162,1.07162,0,0,0,.31824-.8341A8.99623,8.99623,0,0,1,21.18628,8.6488L19.8678,10.13464a.5.5,0,0,0,.314.82825l6.18421.74732a.5.5,0,0,0,.54571-.615L25.43433,5.0437a.5.5,0,0,0-.85975-.21326L23.18683,6.39429a11.89341,11.89341,0,0,0-7.17121-2.39478c-.24218,0-.48632.00733-.73046.022A12.00008,12.00008,0,0,0,4.00092,16.16382a.93076.93076,0,0,0,.24951.68677,1.08451,1.08451,0,0,0,.61676.3247l1.00909.12207A1.03419,1.03419,0,0,0,6.68359,17.03613Z";
	}
}

export default RefreshIcon;
